import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ToolbarComponent } from '../../../shared/components/toolbar/toolbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IUser } from '../../../user/model/user.model';
import { CourseService } from '../../services/course.service';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ICourse } from '../../models/course.model';
import { CategoryService } from '../../../category/services/category.service';
import { ICategory } from '../../../category/model/category.model';
import { ICourseStatus } from '../../models/courseStatus.model';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LanguageService } from '../../../shared/services/language.services';
import { BillingService } from '../../../financials/services/billing.service';
import { stripeAccount } from '../../../financials/model/stripe-account.model';
import { GeneralDataComponent } from '../courseGeneralData/courseGeneralData.component';
import { ModulesDataComponent } from '../courseModule/courseModuleData/courseModuleData.component';
import { CourseProgressBarComponent } from '../courseProgressBar/courseProgressBar.component';
import { CourseLessonDataComponent } from '../courseLesson/courseLessonData/courseLessonData.component';
import { CourseReviewComponent } from '../courseReview/courseReview.component';
import { Store } from '@ngrx/store';
import { courseActions } from '../../store/course.actions';

@Component({
    selector: 'clp-details-course',
    styleUrls: ['./courseDetails.component.scss'],
    templateUrl: './courseDetails.component.html',
    imports: [
    ToolbarComponent,
    TranslateModule,
    GeneralDataComponent,
    ModulesDataComponent,
    CourseProgressBarComponent,
    CourseReviewComponent,
    CourseLessonDataComponent
],
    providers: [
        CategoryService,
        CourseService,
        ToastrService,
        DatePipe,
        BrowserAnimationsModule,
        LanguageService,
        BillingService
    ]
})
export class CourseDetailsComponent implements OnInit {
    private _location = inject(Location);
    private route = inject(ActivatedRoute);
    private store = inject(Store);

    stepNumber: number;
    ICourseStatus = ICourseStatus;
    courseStatuses: { value: ICourseStatus, label: string }[] = [];
    categories$: ICategory[] = [];
    courseForm!: FormGroup;
    course$!: Observable<ICourse>;
    courseId!: string | null;
    edit: boolean = false;
    user$!: Observable<IUser >;
    imageUrl: string | undefined;
    currentImageFile?: string;
    account$!: Observable<stripeAccount>;
    account!: stripeAccount;
    nextOrder$! : Observable<number>;
    @ViewChild(GeneralDataComponent) generalDataComponent!: GeneralDataComponent;
    readonly createStepLabels: string[] = [
      'course.general-tab',
      'course.modules-tab',
      'course.lessons-tab',
      'course.review-tab'
    ];

  constructor() {
    this.stepNumber = 1; // Progress value as a percentage (0-100)
  }

  ngOnInit(): void {
    this.courseId = this.route.snapshot.paramMap.get('id');
    if (this.courseId) {
      this.edit = true;
      this.store.dispatch(courseActions.getCourse(this.courseId));
    } else {
      this.edit = false;
      this.course$ = new Observable<ICourse>();
    }
  }

  backClicked(): void {
    this._location.back();
  }

  moveNext(): void {
    if (this.stepNumber < this.totalSteps) {
      if (this.saveStep()) {
        this.stepNumber++;
      }
    }
  }

  movePrevious(): void {
    if (this.stepNumber > 1) {
      if (this.saveStep()) {
        this.stepNumber--;
      }
    }
  }

  saveStep(): boolean {
    switch (this.stepNumber) {
      case 1:
        return this.generalDataComponent.saveCourse();
      case 2:
        // Save modules data
        return true;
      case 3:
        // Save lessons data
        return true;
      case 4:
        // Save review data
        return true;
      default:
        console.error('Invalid step number');
        return false;
      }
  }

  get stepLabels(): string[] {
    return this.createStepLabels;
  }

  get totalSteps(): number {
    return this.stepLabels.length;
  }
}



